import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { EllipsisVertical } from '@octopus-do/octopus-storybook/icons'
import React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  className: string
}

export const ChangesItemMenuBtn = React.forwardRef<HTMLButtonElement, Props>(
  ({ className }, ref) => {
    const { active, toggle } = DropdownMenu.useTrigger()

    return (
      <button
        ref={ref}
        className={clsJoin(css.button, className, active && css.active)}
        onClick={toggle}
      >
        <EllipsisVertical />
      </button>
    )
  }
)
